import styled from 'styled-components'
import AppLink from 'Components/AppLink'

import { BREAK_POINT_MD, BREAK_POINT_SM } from '@CSSVars/variables'
import {
  TERTIARY_COLOR, GREY_BACKGROUND, TERTIARY_DARK_COLOR,
  SELECTED_ITEM_BG_COLOR, CLICKABLE_COLOR, TEXT_GREY,
  LINK_COLOR, FONT_BASE_COLOR,
} from '@CSSVars/colors'

export const _ReadMoreContainer = styled.div`
  margin-bottom: 40px;

  @media (hover: hover){
    button:hover{
      color:${CLICKABLE_COLOR};
    }
  }
  button:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
  @media screen and (max-width: 768px) {
    margin-bottom: 24px;
    padding-bottom: 16px;
  }
`

export const _FeatureListingAgent = styled.div`
  width: auto;
  margin: 20px 0;
  background-color: ${GREY_BACKGROUND};
  border-radius: 10px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  > a {
    color: ${LINK_COLOR};
    border: 1px solid ${LINK_COLOR};
    border-radius: 10px;
    padding: 12px;
  }


  @media screen and (max-width: ${BREAK_POINT_SM}) {
    flex-direction: column;

    > a {
      margin-top: 12px;
    }
  }
`

export const _FeatureListingAgentInfo = styled.div`
  span {
    padding: 4px 6px;
    margin-bottom: 12px;
    // background-color: ${LINK_COLOR};
    color: white;
    border-radius: 4px;
    display: inline-block;
    font-size: 11px;
    // opacity: .7;
    color: ${LINK_COLOR};
    background: rgba(0, 151, 167, 0.1);
  }

  >div {
    margin-bottom: 8px;
    color: ${TEXT_GREY};
    a {
      color: ${LINK_COLOR};
      text-decoration: underline;
    }
  }
`
export const _FeatureListingAgentName = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: ${FONT_BASE_COLOR} !important;
`


export const _MediaContainer = styled.div`
  margin-top: 10px;
`

export const _VirtualTourBtn = styled(AppLink)`
  width: 376px;
  height: 94px;
  padding: 10px 0 16px;
  max-width: 100%;
  margin-top: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${GREY_BACKGROUND};
  border-radius: 10px;
  a {
    width: 100%;
    padding-right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      color: ${TERTIARY_COLOR};
    }
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
  }
`


export const _VirtualTourTitle = styled.div`
  font-weight: 600;
  line-height: 24px;
`

export const _VirtualTourSvg = styled.div`
  width: 175px;
  height: 44px;
  margin-top: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${TERTIARY_COLOR};
  border-radius: 10px;

  div {
    color: ${TERTIARY_COLOR};
  }

  svg {
    fill: ${TERTIARY_COLOR};
    margin-right: 6px;
  }

  @media (hover:hover) {
    &:hover {
      border: 1px solid ${TERTIARY_DARK_COLOR};
     div {
          color: ${TERTIARY_DARK_COLOR};
        }
     svg {
        fill: ${TERTIARY_DARK_COLOR};
      }
      }
  }

  &:active {
    border: 1px solid ${TERTIARY_DARK_COLOR};
    background: ${TERTIARY_DARK_COLOR};
    div {
      color: white;
    }
    svg {
      fill: white;
    }
  }
`
export const _OpenHouseTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 24px;
`
